import { Stack, Typography } from "@mui/material";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";

const NoData = () => {
  const { bt } = useBizTypeTranslation();
  return (
    <Stack
      width='100%'
      height='100%'
      justifyContent='center'
      alignItems='center'
    >
      <Typography variant="h6" fontWeight='bold'>
        {bt("NO_DATA")}
      </Typography>
    </Stack>
  )
}
export default NoData